module.exports = __webpack_public_path__ + "static/media/printing-services-img7.f3e62c49.jpg";